import { CATEGORY_CHANCES, CATEGORY_INFOS, CATEGORY_RISKS } from '@/model/post/categories'

export default {
    create: 'New',
    category: {
        [CATEGORY_INFOS]: 'Information',
        [CATEGORY_CHANCES]: 'Chances',
        [CATEGORY_RISKS]: 'Risks'
    },
    empty: {
        title: 'Looking for content?',
        info: 'Unfortunately there is nothing to see here yet.',
        action: 'Create a post!'
    }
}
